function toUrl(value) {
  try {
    if (value instanceof URL) return value;
    return new URL(String(value || ""), "https://staging.afrimed.tech");
  } catch {
    return new URL("https://staging.afrimed.tech/auth/callback");
  }
}

export function parseAuthCallbackHash(hash = "") {
  const clean = String(hash || "").replace(/^#/, "");
  return new URLSearchParams(clean);
}

export function getAuthCallbackUrlError(value) {
  const url = toUrl(value);
  const hashParams = parseAuthCallbackHash(url.hash);
  const error =
    String(url.searchParams.get("error") || hashParams.get("error") || "").trim();
  const errorCode =
    String(url.searchParams.get("error_code") || hashParams.get("error_code") || "").trim();
  const errorDescription =
    String(
      url.searchParams.get("error_description") ||
        hashParams.get("error_description") ||
        "",
    ).trim();

  if (!error && !errorCode && !errorDescription) return null;

  const message = errorDescription || errorCode || error || "Sign-in link could not be verified.";
  const lower = `${error} ${errorCode} ${errorDescription}`.toLowerCase();
  const expired =
    lower.includes("otp_expired") ||
    lower.includes("expired") ||
    lower.includes("invalid or has expired") ||
    lower.includes("link is invalid");

  return {
    source:
      hashParams.get("error") || hashParams.get("error_code") || hashParams.get("error_description")
        ? "hash"
        : "query",
    error,
    errorCode,
    errorDescription,
    message,
    expired,
  };
}

export function shouldRecoverExistingSessionAfterCallbackError(callbackError) {
  if (!callbackError) return true;
  if (callbackError.expired) return false;
  return false;
}
